<ds-toggle
  [checked]="navSwitchState()"
  [label]="'nav_switch_label' | translate"
  [ariaLabel]="'nav_switch_label' | translate"
  [labelColor]="labelColor"
  (valueChange)="onValueChange($event)"
>
</ds-toggle>
